import Immutable                                                 from 'immutable';
import { CHANGE_PARAMETER, QUOTE_SUCCESS, SELECT_PRICE_SUCCESS } from 'pu-redux/actions/QuoteActions';
import DefaultRigidFlexParameters                                from '../data/DefaultRigidFlexParameters';


const updateValue = (name, value, state) => {
  switch (name) {
    case 'qty1':
      return state.setIn(['quantities', 0], value);
    case 'qty2':
      return state.setIn(['quantities', 1], value);
    case 'qty3':
      return state.setIn(['quantities', 2], value);
    case 'qty4':
      return state.setIn(['quantities', 3], value);
    default:
      return state.set(name, value);
  }
};

const parameters = (state = Immutable.fromJS(DefaultRigidFlexParameters), action) => {
  switch (action.type) {
    case CHANGE_PARAMETER: {
      const { name, value } = action;
      return updateValue(name, value, state);
    }
    case QUOTE_SUCCESS: {
      return state.withMutations((s) => {
        s.set('product_quote_number', action.quote.number)
          .set('row_selected', '')
          .set('column_selected', '')
          .set('supplier_selected', '');
      });
    }

    case SELECT_PRICE_SUCCESS: {
      const sp = action.selectedPrice;
      return state.withMutations((s) => {
        s.set('row_selected', sp.row_selected)
          .set('column_selected', sp.column_selected)
          .set('supplier_selected', sp.supplier);
      });
    }

    default:
      return state;
  }
};

export default parameters;
